function getGroup(groupID, groups) {
  return groups.find((group) => group.groupID === groupID);
}

function getNestedGroupLevel(group, groups) {
  let level = 0;
  let parentID = group.parentGroupID;

  while (parentID) {
    level++;
    const parentGroup = getGroup(parentID, groups);
    parentID = parentGroup?.parentGroupID;
  }
  return level;
}

function getGroupsWithNestedLevel({ groups, everyoneGroupName }) {
  return groups?.map((group, index) => ({
    ...group,
    isEveryoneGroup: group?.isEveryoneGroup
      ? group.isEveryoneGroup
      : group.groupName === everyoneGroupName,
    level: getNestedGroupLevel(group, groups),
  }));
}

function getNestedGroupIDsFromParentID(parentID, array) {
  let descendants = [];

  function findChildren(parentID) {
    array.forEach((item) => {
      if (item.parentGroupID === parentID) {
        descendants.push(item.groupID);
        findChildren(item.groupID);
      }
    });
  }

  findChildren(parentID);
  return descendants;
}

function getAllDescendantGroupIDsFromParentIDsArray(parentIDsArray, array) {
  let descendants = [];

  function findChildren(parentID) {
    array?.forEach((item) => {
      if (item.parentGroupID === parentID) {
        descendants.push(item.groupID);
        findChildren(item.groupID);
      }
    });
  }

  parentIDsArray?.forEach((parentID) => findChildren(parentID));

  return descendants;
}

export {
  getNestedGroupLevel,
  getGroup,
  getGroupsWithNestedLevel,
  getNestedGroupIDsFromParentID,
  getAllDescendantGroupIDsFromParentIDsArray,
};
